import { Table } from "antd";

const FlightDetailsTable = ({ flightDetails = [] }) => {
  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (text) => <span className="font-semibold text-blue-900">{text}</span>,
    },
    {
      title: "From",
      dataIndex: "from",
      key: "from",
      render: (text) => <span className="text-blue-900">{text}</span>,
    },
    {
      title: "To",
      dataIndex: "to",
      key: "to",
      render: (text) => <span className="text-blue-900">{text}</span>,
    },
    {
      title: "Flight",
      dataIndex: "flight",
      key: "flight",
      render: (text) => <span className="text-blue-900">{text}</span>,
    },
    {
      title: "Dept.",
      dataIndex: "departure",
      key: "departure",
      render: (text) => <span className="text-blue-900">{text}</span>,
    },
    {
      title: "Arr.",
      dataIndex: "arrival",
      key: "arrival",
      render: (text) => <span className="text-blue-900">{text}</span>,
    },
  ];

  return (
    <div className="mt-6">
      <h6 className="mb-3 text-sm font-semibold text-blue-900">
        Flight Details
      </h6>

      <Table
        columns={columns}
        dataSource={flightDetails}
        rowKey={(record, index) => index}
        pagination={false}
        bordered
        className="flight-table"
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default FlightDetailsTable;